import React from 'react';
import Card from "./Card";
import "./css/Works.css";
import Tilt from "react-tilt";
import squareOne from "./resources/squareOne.png";

function Works() {
    return (

        <div className="works">
            <Tilt className="Tilt" options={{ max: 25 }}>
                <a href="https://sqaureone.herokuapp.com/login" className="project-link" target="_blank" rel="noreferrer" ><Card logo={squareOne} title={"Square One"} appStore={false} playStore={false} website={true} /></a>
            </Tilt>
        </div >

    )
}

export default Works
